import AxiosClient from '../utils/AxiosClient';

export const signup = async ({
  email, phone_number, password, businessName, referral_code, type
}) => {
  const client = await AxiosClient();
  return (await client.post('business/signup', {
    email, phone_number, password, business_name: businessName, referral_code, type
  }))?.data;
};

export const sendOTP = async ({ phone_number,type }) => {
  const client = await AxiosClient();
  return (await client.post('business/resend-otp', {
    phone_number,type,
  }))?.data;
};

export const confirmOTP = async ({ phone_number, otp, type }) => {
  const client = await AxiosClient();
  return (await client.post('business/confirm-otp', {
    phone_number, otp, type,
  }))?.data;
};

export const sendEmail = async ({ email }) => {
  const client = await AxiosClient();
  return (await client.post('business/resend-email', { email }))?.data;
};

export const confirmEmail = async ({ token, type }) => {
  const client = await AxiosClient();
  return (await client.post('business/confirm-email', { token, type }))?.data;
};

export const initResetPassword = async ({ email, type}) => {
  const client = await AxiosClient();
  return (await client.post('business/password-reset-email', { email, type }))?.data;
};

export const initPINReset = async ({ }) => {
  const client = await AxiosClient();
  return (await client.post('auth/reset/pin/otp', { }))?.data;
};

export const resetPIN = async ({ otp, new_pin }) => {
  const client = await AxiosClient();
  return (await client.post('auth/reset/pin', { otp, new_pin }))?.data;
};

export const resetPassword = async ({ token, password, type }) => {
  const client = await AxiosClient();
  return (await client.post('business/reset-password', { token, password, type }))?.data;
};

export const login = async ({ email, password, type }) => {
  const client = await AxiosClient();
  return (await client.post('business/login', { email, password, type }))?.data;
};

export const updatePassword = async ({ oldPassword, newPassword }) => {
  const client = await AxiosClient();
  return (await client.post('settings/password', { old_password: oldPassword, new_password: newPassword }))?.data;
};

export const updatePin = async ({ oldPin, newPin }) => {
  const client = await AxiosClient();
  return (await client.post('settings/pin', { old_pin: oldPin, new_pin: newPin }))?.data;
};

